__turbopack_context__.v({
  "active": "style-module-scss-module__XWn5SW__active",
  "chevron": "style-module-scss-module__XWn5SW__chevron",
  "component": "style-module-scss-module__XWn5SW__component",
  "dropdown": "style-module-scss-module__XWn5SW__dropdown",
  "panel": "style-module-scss-module__XWn5SW__panel",
  "selected": "style-module-scss-module__XWn5SW__selected",
  "theme-dark": "style-module-scss-module__XWn5SW__theme-dark",
  "theme-rounded": "style-module-scss-module__XWn5SW__theme-rounded",
});
